import { Button, Input, Layout, message, Modal, Popconfirm, Space, Spin, Table, Tabs, Upload } from "antd";
import PageHeader from "../../comps/pageHeader";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchClassroom, FetchSessionList, generatePupilsXlsx, generateSinglePupil } from "../prof/profsSlice";
import { useCookies } from "react-cookie";
import {
    ExclamationCircleTwoTone
} from '@ant-design/icons'
import AddPupil from "../../comps/addPupil";
import { RemovePupilFromClass, setRemovePupilFromClassSuccess, UploadXLSX } from "./classroomsSlice";
import LessonSelectionModal from "../../comps/lessonSelection";
import moment from "moment";


export default function Classroom(props) {

    let { id } = useParams();

    // eslint-disable-next-line no-unused-vars
    const [cookies, setCookies, removeCookie] = useCookies();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [file, setFile] = useState(null);
    const [xlsxFilePath, setXlsxFilePath] = useState("");
    const [existingPupils, setExistingPupils] = useState([]);

    const [isAddPupilOpen, setIsAddPupilOpen] = useState(false);
    const [isImportPupilsXLSXOpen, setIsImportPupilsXLSXOpen] = useState(false);
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
    const [isWarningPupilsModalOpen, setIsWarningPupilsModalOpen] = useState(false);
    const [isLSMOpen, setIsLSMOpen] = useState(false);

    const classroomSingle = useSelector((state) => state.profs.classroomSingle);
    const isFetchingClassroom = useSelector((state) => state.profs.isFetchingSingleClassroom);
    const uploadXLSXResult = useSelector((state) => state.classrooms.uploadXLSXResult);
    const isUploadingXLSX = useSelector((state) => state.classrooms.isUploadingXLSX);
    const isGeneratingPupilsXlsx = useSelector((state) => state.profs.isGeneratingPupilsXlsx);
    const generatePupilsXlsxSuccess = useSelector((state) => state.profs.generatePupilsXlsxSuccess);
    const getSessionListSuccess = useSelector((state) => state.profs.getSessionListSuccess);
    const isFetchingSessionList = useSelector((state) => state.profs.isFetchingSessionList);
    const removePupilFromClassSuccess = useSelector((state) => state.classrooms.removePupilFromClassSuccess);

    useEffect(() => {
        dispatch(fetchClassroom(cookies, { id }));
        dispatch(FetchSessionList(cookies, { classId: id }));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!uploadXLSXResult) return;
        setXlsxFilePath(uploadXLSXResult.doc_url);
        setIsImportPupilsXLSXOpen(false);
        setIsWarningModalOpen(true);
    }, [uploadXLSXResult]);

    useEffect(() => {
        if (!removePupilFromClassSuccess) return;
        dispatch(fetchClassroom(cookies, { id }));
        dispatch(setRemovePupilFromClassSuccess(null));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [removePupilFromClassSuccess])

    useEffect(() => {
        if (!generatePupilsXlsxSuccess) return;

        if (generatePupilsXlsxSuccess.alreadyExistingPupils?.length < 1) {

            dispatch(fetchClassroom(cookies, { id }));
            setIsWarningModalOpen(false);
            message.success("Vous avez généré les comptes des élèves avec succès.");
            return;
        }
        setExistingPupils(generatePupilsXlsxSuccess.alreadyExistingPupils);
        setIsWarningModalOpen(false);
        setIsWarningPupilsModalOpen(true);
        message.success(`Vous avez généré les comptes des élèves avec succès à l'exception de ${generatePupilsXlsxSuccess.alreadyExistingPupils?.length} élèves.`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generatePupilsXlsxSuccess]);

    useEffect(() => {
        console.log(existingPupils);
    }, [existingPupils])

    const handleOkImportXLSX = () => {
        if (!file) {
            message.warning("Vous devez envoyer un fichier rempli.");
            return;
        }
        dispatch(UploadXLSX(cookies, { folder_path: id }, file));
    }

    const handleGeneratePupils = () => {
        if (!xlsxFilePath) {
            message.warning("Vous devez avoir envoyé un fichier.")
            return;
        }
        dispatch(generatePupilsXlsx(cookies, { classId: id, documentPath: xlsxFilePath }));
    }

    const handleConfirmWarningPupils = () => {
        dispatch(fetchClassroom(cookies, { id }));
        setIsWarningPupilsModalOpen(false);
    }

    const columnsClassroom = [
        {
            title: 'Nom prénom',
            dataIndex: 'name',
            key: '_id',
            render: (text) => (<p>{text}</p>),
            width: "600px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Adresse mail',
            dataIndex: 'email',
            key: 'email',
            render: (text) => (<p>{text}</p>),
            // width: "600px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Actions',
            dataIndex: '_id',
            key: '_id',
            render: (data, record) => (
                <div >
                    <Popconfirm
                        placement="topLeft"
                        title={"Supprimer un élève"}
                        description={"Êtes-vous sûr de vouloir supprimer cet élève ?"}
                        okText="Oui"
                        cancelText="Non"
                        onConfirm={() => { dispatch(RemovePupilFromClass(cookies, { classId: id, pupilId: data })) }}
                    >
                        <Button
                            style={{ width: "6vw", marginRight: "8px", color: "#39B13D", border: "none" }}
                            // onClick={() => { message.warning("Not implemented yet"); }}
                        >
                            Supprimer
                        </Button>
                    </Popconfirm>
                </div>
            ),
            width: "10vw"
            // ...getColumnFilterStatusProps('sent')
        }

    ];

    const columnsSessions = [
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: '_id',
            render: (date) => (<p>{moment(date).format('YYYY-MM-DD')}</p>),
            // width: "600px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Module',
            dataIndex: ['lesson', 'module', 'seq'],
            key: '_id',
            render: (number) => (<p>Module {number}</p>),
            // width: "600px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Leçon',
            dataIndex: ['lesson', 'name'],
            key: '_id',
            render: (lessonName) => (<p>{lessonName}</p>),
            // width: "600px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Nbr. d’élèves présents',
            dataIndex: 'sessionUserExercises',
            key: '_id',
            render: (data) => (<p>{data.length}</p>),
            // width: "600px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Détails',
            dataIndex: '_id',
            key: '_id',
            render: (data, record) => (
                <div >
                    <Button
                        style={{ width: "6vw", marginRight: "8px", color: "#39B13D", border: "none" }}
                        onClick={() => { navigate(`/dashboard/classes/sessionHistory/${id}-${data}`); }}
                    >
                        Voir
                    </Button>
                </div>
            ),
            width: "10vw"
            // ...getColumnFilterStatusProps('sent')
        }

    ];

    const tabItems = [
        {
            key: '1',
            label: 'Liste des élèves de la classe',
            children: (
                <div style={{ padding: "12px 0px" }}>
                    <Table
                        loading={isFetchingClassroom}
                        dataSource={classroomSingle?.pupils}
                        // pagination={{
                        //     total: CodeListResult?.nCodes,
                        //     pageSize: filterData.docsPerPage,
                        //     showSizeChanger: true,
                        //     pageSizeOptions: [10, 15, 20, 30, 40, 50],
                        //     showQuickJumper: true,
                        //     showTotal: (total, range) => (<>Nombre de codes : {total} </>),
                        // }}
                        columns={columnsClassroom}
                    // onChange={onChangePage}
                    />
                </div>
            ),

        },
        {
            key: '2',
            label: 'Historique des leçons',
            children: (
                <div style={{ padding: "12px 0px" }}>
                    <Table
                        loading={isFetchingSessionList}
                        dataSource={getSessionListSuccess}
                        columns={columnsSessions}
                    ></Table>
                </div>
            )
        },
    ]

    return (
        <Space direction="vertical" style={{ width: '100%' }} size={[0, 48]}>
            <Layout>
                <PageHeader title={classroomSingle?.classroom.name} breadcrumbItems={[classroomSingle?.classroom.name, "Liste des élèves"]}>
                    <Button
                        className="buttonStyle"
                        style={{ marginTop: "20px", height: "32px", padding: "4px 24px" }}
                        onClick={() => { navigate("/dashboard/classes/classList") }}
                    > Revenir à la liste des classes </Button>
                </PageHeader>
                <div style={{
                    margin: "2em",
                    padding: "2em 4vw 2em 4vw",
                    display: "flex",
                    direction: "column",
                    justifyContent: "space-around",
                    backgroundColor: "#424242"
                }}>
                    <div className="buttonContainer">
                        <p style={{ color: "#fff", fontWeight: "600" }}>Ajouter un élève :</p>
                        <Button
                            className="buttonStyle"

                            onClick={() => setIsAddPupilOpen(true)}
                        >
                            Ajouter
                        </Button>
                    </div>
                    <div className="buttonContainer">
                        <p style={{ color: "#fff", fontWeight: "600" }}>Importer une liste d’élèves</p>
                        <Button
                            className="buttonStyle"

                            onClick={() => setIsImportPupilsXLSXOpen(true)}
                        >
                            Importer
                        </Button>
                    </div>
                    <div className="buttonContainer">
                        <p style={{ color: "#fff", fontWeight: "600" }}>lancer une leçon</p>
                        <Button
                            className="buttonStyle"
                            onClick={() => setIsLSMOpen(true)}
                        >
                            Lancer
                        </Button>
                    </div>
                </div>
                <div
                    style={{
                        margin: "2em",
                        padding: "1em 0em",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#F5F5F5"
                    }}
                >
                    <Tabs
                        style={{ backgroundColor: "#Fff", padding: "8px 24px" }}
                        items={tabItems}
                        onChange={() => {
                            dispatch(fetchClassroom(cookies, { id }));
                            dispatch(FetchSessionList(cookies, { classId: id }));
                        }}
                    >

                    </Tabs>
                </div>
                <AddPupil open={isAddPupilOpen} setIsAddPupilOpen={setIsAddPupilOpen} classId={id}></AddPupil>

                <Modal
                    title="Importer la liste d’élèves"
                    open={isImportPupilsXLSXOpen}
                    okText={isUploadingXLSX ? <Spin /> : "Importer"}
                    cancelText="Annuler"
                    onCancel={() => setIsImportPupilsXLSXOpen(false)}
                    onOk={handleOkImportXLSX}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            gap: "24px",
                            margin: "32px 0px"
                        }}
                    >
                        <Upload
                            maxCount={1}
                            beforeUpload={(file) => {
                                setFile(file);
                                return false;
                            }}
                        >
                            <Button
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#39B13D",
                                    color: "#fff",
                                    borderColor: "transparent"
                                }}
                            // onClick={() => message.info}
                            >+ Upload un fichier excel</Button>
                        </Upload>
                        <Button
                            style={{
                                padding: "0px"
                            }}
                        >
                            <a
                                style={{
                                    // width:"100%",
                                    height: "22px",
                                    padding: "8px 16px"

                                }}
                                href="https://cactusfrance.com/public/uploads/TemplateImporterEleves.xlsx" target="_blank" rel="noreferrer" >Télécharger l'exemple</a>

                        </Button>
                    </div>
                </Modal>

                <Modal
                    title={<div style={{ display: "flex", flexDirection: "row" }}>
                        <ExclamationCircleTwoTone twoToneColor="#FAAD14" style={{ marginRight: "8px" }} />
                        <p>Attention !</p>
                    </div>}
                    open={isWarningModalOpen}
                    cancelText="Annuler"
                    onCancel={() => { setIsWarningModalOpen(false) }}
                    okText={isGeneratingPupilsXlsx ? <Spin /> : "Confirmer"}
                    onOk={handleGeneratePupils}
                >
                    <p style={{ marginLeft: "16px" }}>Rappel que la structure va être débité du nombre de contacts indiqués, merci de vérifier les informations.</p>
                </Modal>

                <Modal
                    title={<div style={{ display: "flex", flexDirection: "row" }}>
                        <ExclamationCircleTwoTone twoToneColor="#FAAD14" style={{ marginRight: "8px" }} />
                        <p>Attention !</p>
                    </div>}
                    open={isWarningPupilsModalOpen}
                    cancelText="Annuler"
                    onCancel={() => { setIsWarningPupilsModalOpen(false); dispatch(fetchClassroom(cookies, { id })); }}
                    okText={"Confirmer"}
                    onOk={handleConfirmWarningPupils}
                >
                    <p style={{ marginLeft: "16px" }}>Certains élèves font partie d’un autre établissement / classe, voulez-vous vraiment les importer ?</p>
                    {existingPupils.map((user) => (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "16px"
                            }}
                        >
                            <Input value={user.name} />
                            <Button
                                onClick={() => {
                                    setExistingPupils(existingPupils.filter(u => u._id.toString() !== user._id.toString()),);
                                }}
                            >Non</Button>
                            <Button
                                style={{
                                    backgroundColor: "#39B13D",
                                    color: "#fff",
                                    borderColor: "transparent"
                                }}
                                onClick={() => {
                                    dispatch(generateSinglePupil(cookies, {
                                        name: user.name,
                                        email: user.email,
                                        password: "RandomPass12",
                                        classId: id
                                    }));
                                    setExistingPupils(existingPupils.filter(u => u._id.toString() !== user._id.toString()),);

                                }}
                            >Oui</Button>
                        </div>
                    ))}
                </Modal>
                <LessonSelectionModal isOpen={isLSMOpen} classId={id} setIsLSMOpen={setIsLSMOpen} />
            </Layout>

        </Space >
    );
}